const PendingLeave = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 64 64"
    >
      <g>
        <path
          d="M15 46h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zm-3-2h2v-2h-2zM16 38h-6a1 1 0 0 1-1-1v-1c0-1.654 1.346-3 3-3h2c1.654 0 3 1.346 3 3v1a1 1 0 0 1-1 1zm-5-2h4c0-.552-.449-1-1-1h-2c-.551 0-1 .448-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M11 43.99h-.021C7.131 43.908 4 40.772 4 37a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1 6.866 6.866 0 0 1-2.103 4.957 7.168 7.168 0 0 1-4.879 2.033c-.534.011-1.008-.43-1.019-.981s.429-1.008.981-1.019a5.175 5.175 0 0 0 3.522-1.467A4.91 4.91 0 0 0 19.897 38H6.105c.475 2.227 2.499 3.939 4.916 3.99a1.001 1.001 0 0 1-.021 2z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M21 50H5a1 1 0 0 1-1-1V37a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1zM6 48h14V38H6zM20 7h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM40 7h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M59 64H5c-2.757 0-5-2.311-5-5.15v-45.6a8.35 8.35 0 0 1 2.329-5.823C3.847 5.861 5.86 5 8 5h2a1 1 0 0 1 0 2H8c-1.594 0-3.097.645-4.232 1.816A6.36 6.36 0 0 0 2 13.25v45.6C2 60.587 3.346 62 5 62h54c1.654 0 3-1.413 3-3.15v-45.6C62 9.804 59.309 7 56 7h-2a1 1 0 0 1 0-2h2c4.411 0 8 3.701 8 8.25v45.6c0 2.84-2.243 5.15-5 5.15z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M50 7h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM30 7h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zM63 21H1a1 1 0 0 1 0-2h62a1 1 0 0 1 0 2zM63 16H1a1 1 0 0 1 0-2h62a1 1 0 0 1 0 2zM12 11c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.654-1.346 3-3 3zm0-9c-.551 0-1 .449-1 1v5c0 .551.449 1 1 1s1-.449 1-1V3c0-.551-.449-1-1-1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M22 11c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.654-1.346 3-3 3zm0-9c-.551 0-1 .449-1 1v5c0 .551.449 1 1 1s1-.449 1-1V3c0-.551-.449-1-1-1zM32 11c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.654-1.346 3-3 3zm0-9c-.551 0-1 .449-1 1v5c0 .551.449 1 1 1s1-.449 1-1V3c0-.551-.449-1-1-1zM42 11c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.654-1.346 3-3 3zm0-9c-.551 0-1 .449-1 1v5c0 .551.449 1 1 1s1-.449 1-1V3c0-.551-.449-1-1-1zM52 11c-1.654 0-3-1.346-3-3V3c0-1.654 1.346-3 3-3s3 1.346 3 3v5c0 1.654-1.346 3-3 3zm0-9c-.551 0-1 .449-1 1v5c0 .551.449 1 1 1s1-.449 1-1V3c0-.551-.449-1-1-1zM45.001 48a1 1 0 0 1-.801-.4l-3-4a1 1 0 0 1 1.6-1.199l3 4A.998.998 0 0 1 45.001 48z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M59 48H45a1 1 0 1 1 0-2h14a1 1 0 1 1 0 2z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M46.999 50a1 1 0 0 1-.893-1.447l1-2a1 1 0 0 1 1.789.895l-1 2a.999.999 0 0 1-.896.553zM56.001 50a1 1 0 0 1-.896-.553l-1-2a1 1 0 0 1 1.789-.895l1 2a1 1 0 0 1-.893 1.447zM56 40a1 1 0 0 1-1-1c0-2.757-2.243-5-5-5s-5 2.243-5 5a1 1 0 1 1-2 0c0-3.859 3.14-7 7-7s7 3.141 7 7a1 1 0 0 1-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M48 40c-.478 0-.877-.335-.977-.783C46.877 39.128 46.521 39 46 39s-.877.128-1.023.217A1 1 0 0 1 43 39c0-1.159 1.262-2 3-2s3 .841 3 2a1 1 0 0 1-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M52 40c-.478 0-.877-.335-.977-.783C50.877 39.128 50.521 39 50 39s-.877.128-1.023.217A1 1 0 0 1 47 39c0-1.159 1.262-2 3-2s3 .841 3 2a1 1 0 0 1-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M56 40c-.478 0-.877-.335-.977-.783C54.877 39.128 54.521 39 54 39s-.877.128-1.023.217A1 1 0 0 1 51 39c0-1.159 1.262-2 3-2s3 .841 3 2a1 1 0 0 1-1 1zM48 40a1 1 0 0 1-1-1c0-3.484.928-7 3-7a1 1 0 0 1 .089 1.996C49.744 34.277 49 35.995 49 39a1 1 0 0 1-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M52 40a1 1 0 0 1-1-1c0-3.005-.744-4.723-1.089-5.004A1 1 0 0 1 50 32c2.072 0 3 3.516 3 7a1 1 0 0 1-1 1z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M50 48a1 1 0 0 1-1-1v-8a1 1 0 1 1 2 0v8a1 1 0 0 1-1 1zM35 46a.999.999 0 0 1-.707-1.707l3-3a.999.999 0 1 1 1.414 1.414l-3 3A.997.997 0 0 1 35 46z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M38 43a.997.997 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414l3 3A.999.999 0 0 1 38 43z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M38 43H25a1 1 0 1 1 0-2h13a1 1 0 1 1 0 2zM15 60H9a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM25 60h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM35 60h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM45 60h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM55 60h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM15 31H9a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM25 31h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM35 31h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM45 31h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4zM55 31h-6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm-5-2h4v-4h-4z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
      </g>
    </svg>
  );
};
export default PendingLeave;
